import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider as ReduxProvider } from "react-redux";
import { createLogger as createReduxLogger } from "redux-logger";
import createSagaMiddleware from "redux-saga";
import "core-js/features/string/starts-with";
import { ConnectedProvider as I18nProvider } from "@quantum/i18n";
import reduceReducers from "reduce-reducers";
import moment from "moment";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";

import { definirModoApp, reducer, chavesI18n } from "./state";
import { createExtendedQuantumAPI, createLocalStorageFrame } from "./api";
import { reducer as remoteDataReducer } from "@quantum/remote-data";
import { modalReducer } from "@quantum/ui";
import { tabsReducer } from "./components/comum";
import { ProvedorDePermissionamentoExcel } from "./components/permissionamento";
import { ScrollArea } from "./components/comum/Scroll";
import { FocusArea } from "./components/focus-area";

import {
  arquivosMedidasSaga,
  buscaAtivosSaga,
  carregarMedidaUsuarioSaga,
  comunicacaoExcelSaga,
  descricaoMedidasSaga,
  medidasSelecionadasSaga,
  periodosSaga,
  obterDatasSelecaoJanelaSaga,
  toogleMedidasSelecionadasDesabilitadoSaga,
  limparSelecaoSaga,
} from "./sagas";

import "react-datetime/css/react-datetime.css";
import "react-bootstrap-modal/lib/css/rbm-complete.css";
import "rc-tooltip/assets/bootstrap_white.css";
import "@quantum/ui/dist/css/index.css";
import "./index.css";

import criarComunicacaoHTTPComExcel from "./excel/comunicacao/http";

import { ExcelApp } from "./components/app";

moment.locale("pt-BR");

const frameApi = createLocalStorageFrame({
  namespace: "@quantum/relatorio/frame/excel",
});

const history = createBrowserHistory();

const loggerMiddleware = createReduxLogger({
  collapsed: true,
  duration: true,
  diff: false,
});

const sagaMiddleware = createSagaMiddleware({
  onError: console.error,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools

const middlewares = [sagaMiddleware];

//if (process.env.REACT_APP_USE_REDUX_LOGGER) {
middlewares.push(loggerMiddleware);
//}

const store = createStore(
  reduceReducers(reducer, remoteDataReducer, modalReducer, tabsReducer),
  composeEnhancers(applyMiddleware(...middlewares))
);

const clienteExcel = criarComunicacaoHTTPComExcel({
  url:
    process.env.REACT_APP_EXCEL_API_URL ||
    "https://relatorioexceltela.azurewebsites.net/api",
  key: process.env.REACT_APP_EXCEL_API_KEY,
  idSessao: document.location.search.replace(/^\?/, ""),
});

let authToken = null;
let apiURL = null;

const api = createExtendedQuantumAPI({
  url: "",
  defaultFeature: "CONFIGURACAO_RELATORIO",
  authToken: () => `Bearer ${authToken}`,
  modoApp: "NORMAL",
  filter: req => ({
    ...req,
    url: req.url.startsWith("/")
      ? `${apiURL}/api${req.url}`
      : `${apiURL}/api/${req.url}`,
  }),
});

sagaMiddleware.run(arquivosMedidasSaga, { api, frameApi });
sagaMiddleware.run(buscaAtivosSaga, { api });
sagaMiddleware.run(carregarMedidaUsuarioSaga, { api });
sagaMiddleware.run(obterDatasSelecaoJanelaSaga, { api });
sagaMiddleware.run(descricaoMedidasSaga, { api });
sagaMiddleware.run(medidasSelecionadasSaga);
sagaMiddleware.run(limparSelecaoSaga, { frameApi });
sagaMiddleware.run(periodosSaga);
sagaMiddleware.run(toogleMedidasSelecionadasDesabilitadoSaga);
sagaMiddleware.run(comunicacaoExcelSaga, {
  api,
  cliente: clienteExcel,
  aoReceberConfiguracoes: ({ apiURL: url, jwt }) => {
    apiURL = url;
    authToken = jwt;
  },
  aoPerderConexao: () => {
    if (process.env.NODE_ENV === "development") {
      console.error("Conexão perdida com o Excel");
    } else if (process.env.NODE_ENV === "production") {
      window.close();
    }
  },
});

store.dispatch(definirModoApp("EXCEL"));

ReactDOM.render(
  <ReduxProvider store={store}>
    <I18nProvider selector={chavesI18n}>
      <ProvedorDePermissionamentoExcel>
        <FocusArea>
          <ScrollArea>
            <Router history={history}>
              <ExcelApp />
            </Router>
          </ScrollArea>
        </FocusArea>
      </ProvedorDePermissionamentoExcel>
    </I18nProvider>
  </ReduxProvider>,
  document.getElementById("root")
);
